import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ADPResourceService as ResourceService } from 'digital-core';


import { CustomIdBase } from 'digital-core';
import { QuestionInfo } from 'common/models/common/question-info';
import { AnswerInfo } from 'common/models/common/answer-info';
	
import {  QuestionsService, ShareDataService} from 'common';

@Component({
  selector: 'gsp-dichotomous-question',
  templateUrl: './dichotomous-question.component.html',
  styleUrls: ['./dichotomous-question.component.css']
})
export class DichotomousQuestionComponent extends CustomIdBase implements OnInit {
  @Input()
  index: number;
  @Input()
  total: number;
  @Input()
  totalQuestions: number;
  @Input()
  question: QuestionInfo;
  @Input()
  demandNeedSection: HTMLElement;
  @Input()
  enabled = true;
  @Input()
  showNumber = true;
  @Input()
  allowUnSelect = false;

  @Output()
  nextStep = new EventEmitter();

  @Output()
  selectedStep = new EventEmitter<number>();

  @Input()
  expanded: boolean;

  @Output()
  selectionChange = new EventEmitter<QuestionInfo>();

  public questionsFormControl: UntypedFormControl;  

    constructor(public resourcesService: ResourceService, private el: ElementRef, private renderer: Renderer2, private cd: ChangeDetectorRef,
       private shareDataService: ShareDataService,
       private questionService:QuestionsService) {
    super();
  }

  ngOnInit() {
  
    if (this.question && !this.question.Answer) {
      this.question.Answer = new AnswerInfo();
    }

    this.questionsFormControl = new UntypedFormControl(
      this.question.Answer.AnswerText
    );

    this.resourceName = this.question.Title;
    this.questionService.resetForm.subscribe((result) => {
      if (result.isRefreshRequired) {
        this.questionsFormControl.reset();
      }
    });
    super.InitControl();
    // this.cd.detectChanges();
  }

  checkState(el) {
    if (this.allowUnSelect) {
      setTimeout(() => {
        if (this.question.Answer && this.question.Answer.AnswerText === el.value) {
          el.checked = false;
          this.renderer.removeClass(el['_elementRef'].nativeElement, 'cdk-focused');
          this.renderer.removeClass(el['_elementRef'].nativeElement, 'cdk-program-focused');
          this.question.Answer.AnswerText = null;
          this.question.Completed = false;
        } 
      })
    }
  }

  getResource(resource: any) {
    return this.resourcesService.getViewResource(resource);
  }

  openPanel() {
    this.expanded = true;
    this.selectedStep.emit(this.index);
    
    this.focus();
  }

  focus() {
    // focus on question when expanded and its not yet answered,
    // and dont do it for first question as user needs to read the headers first.
    let scope = this;
    setTimeout(() => {
      if (!scope.question.Completed && scope.index > 0 && scope.question.ShowExpandedOnLoad === false) {
        scope.el.nativeElement.scrollIntoView({block: 'center'}); 
        // (center) this will align the element to the center of screen.
      }
    }, 1);
  }

  selectionChanged(_event: any) {
    let scope = this;
    setTimeout(() => {
      if (scope.questionsFormControl.value) {
        scope.question.Answer.AnswerText = scope.questionsFormControl.value;
        scope.question.Completed = true;
      } else {
        scope.question.Completed = false;
      }
      scope.nextStep.emit();
      scope.selectionChange.emit(this.question);
    });
  }

  getQuestionTextId() {
    if (this.customElementId) {
      return this.customElementId.concat('_Text');
    }
  }
  
  getQuestionIndexId(index: number) {
    if (this.customElementId) {
      return this.customElementId.concat('_Index_', index.toString());
    }
  } 

  getRadioButtonId(customName: string) {
    return this.shareDataService.getRadioButtonId(this.customElementId, customName);
  }
}
